/**
 * A reason why a lead list cannot be used to dial predictively.
 */
export enum LeadListPredictiveDialHaltReason {

  /**
   * A contact was about to be dialed twice.
   * 
   * This indicates an error in the contact reservation system. 
   */
  ContactRedialed = 'contactRedialed',

  /**
   * The system has detected that none of the users in the predictive dial queue are being routed calls.
   * 
   * This is likely due to users failing to leave a queue.
   */
  UnresponsiveUsers = 'unresponsiveUsers',

  /**
   * A user has chosen to disable predictive dialing for this lead list.
   */
  DisabledByUser = 'disabledByUser',

  /**
   * For shuffle lead lists, there is no available source.
   * To fic this, the source lead lists must be enabled for predictive dialing.
   */
  NoAvailableSource = 'noAvailableSource'
}